module.exports = __webpack_public_path__ + "static/media/starter-hover.a69c23ea.png";